export const GeneralFormats = {
    dateFormat: 'DD/MM/YYYY',
    dateTimeFormat: 'DD/MM/YYYY HH:mm A',
};

export const INSTRUCTIONS_ROUTE = '/dashboard/instructions';
export const PARTNER_DOCTOR_FAQ_ROUTE = `${INSTRUCTIONS_ROUTE}/partner-doctor-faq`;
const PARTNER_DOCTOR_FAQ_IMAGE_BASE = '/assets/images/partner-doctor-faq';
export const partnerDoctorFaqPageSrc = (lang, page) => `${PARTNER_DOCTOR_FAQ_IMAGE_BASE}/${lang}-${page}.webp`;
export const partnerDoctorFaqThumbnailSrc = (lang) => `${PARTNER_DOCTOR_FAQ_IMAGE_BASE}/${lang}-thumb.webp`;